import React from "react";
import "../css/register.css";
import "../css/nav.css";
import "../css/dashboard.css";
import { NavLink, Outlet } from "react-router-dom";
import { useAuth } from "./auth";

const Dashboard = () => {
  const { user } = useAuth();
  return (
    <div>
      <div className="welcome-msg">Welcome @ {user}</div>
      <div className="dashboard-header">PG Catalogue</div>
      <div className="marquee">
        <p>
          You can Create/add entire PG details here... i.e adding & updating
          rooms, adding & updating guest details many more...
        </p>
      </div>
      <div className="container-cls">
        <div className="subcontainer-cls">
          <div className="sublink-cls">
            <NavLink to="NewPG">NewPG</NavLink>
            <NavLink to="MyPGDetails">MyPGDetails</NavLink>
            {/* <NavLink to="AddExpense">AddExpense</NavLink> */}
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
